import {
  AccountingBasis,
  TaxClassificationEntityTypeEnum,
} from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { CorporationType, Country, Frequency } from '@prisma/client';

export type TAddressParams = {
  addressLine1: string;
  addressLine2?: string;
  addressLine3?: string;
  city: string;
  state: string;
  postalCode: string;
  country: Country;
};

export interface UpdateBusinessEntityParams {
  legalName?: string;
  dbaName?: string;
  formationDate?: string;
  jurisdiction?: string | null;
  incorporationCountry?: Country;
  corporationType?: CorporationType;
  entityLegalFormId?: string;
  fiscalYearDay?: number;
  fiscalYearMonth?: number;
  governanceStructureCode?: string;
  entityEmail?: string;
  /** The primary tax id, such as a US corporation's EIN. Null removes it. */
  primaryTaxId?: string | null;
  /** The identifier the jurisdiction issued at formation. Null removes it. */
  uniqueIdentifierFromJurisdiction?: string | null;
  /** Recorded as the principal place of business. */
  operatingAddress?: TAddressParams;
  businessCode?: string;
  businessDescription?: string;
  dateOfClosure?: string;
  accountingBasis?: AccountingBasis;
  taxedAs?: TaxClassificationEntityTypeEnum;
  countrySpecificFields?: {
    US?: {
      registeredAgentName?: string;
      registeredAgentAddress?: TAddressParams;
    };
  };
  bookkeepingFrequency?: Frequency;

  publicFacingWebsiteUrl?: string;

  isIncorporationInProgress?: boolean;
}

const updateBusinessEntity = async (
  businessEntityId: number,
  body: UpdateBusinessEntityParams
) => {
  const response = await fetcher(`business-entities/${businessEntityId}`, {
    method: 'PATCH',
    body,
  });

  return response;
};

export { updateBusinessEntity };
